(function () {
  if (window.__cartUpsellLoadingInitialized) return;
  window.__cartUpsellLoadingInitialized = true;

  function findUpsellButton(form) {
    var buttons = document.querySelectorAll('.upsell__add-btn');

    for (var index = 0; index < buttons.length; index += 1) {
      if (
        buttons[index].form === form ||
        buttons[index].getAttribute('form') === form.id
      ) {
        return buttons[index];
      }
    }

    return null;
  }

  function startButton(button) {
    if (!button || !button.isConnected) return;

    button.classList.add('loading');
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.remove('hidden');
  }

  function resetButton(button) {
    if (!button || !button.isConnected) return;

    button.classList.remove('loading');
    button.removeAttribute('aria-disabled');
    button.removeAttribute('aria-busy');
    button.disabled = false;

    var spinner = button.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  function getUpsellForm(button) {
    if (!button) return null;
    if (button.form) return button.form;

    var formId = button.getAttribute('form');
    return formId ? document.getElementById(formId) : null;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (!(event.target instanceof Element)) return;

      var button = event.target.closest('.upsell__add-btn');
      if (!button || button.disabled) return;

      var form = getUpsellForm(button);
      if (
        !form ||
        form.dataset.type !== 'add-to-cart-form' ||
        !form.closest('product-form[data-is-cart-upsell="true"]')
      ) {
        return;
      }

      // Start on the click so the visible button animates before the
      // product-form submit handler starts the cart request.
      startButton(button);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.type !== 'add-to-cart-form') return;
      if (!form.closest('product-form[data-is-cart-upsell="true"]')) return;

      var button = findUpsellButton(form);
      if (!button) return;

      startButton(button);
      button.disabled = true;

      window.setTimeout(function () {
        resetButton(button);
      }, 10000);
    },
    true
  );
})();